import { createFileRoute } from '@tanstack/react-router';
import { AdminWatchlistPage } from '../../features/tenancy';

export const Route = createFileRoute('/admin/watchlist')({ component: AdminWatchlistPage });
